var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomangM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.0225 14.5454L64.2589 41.3091L37.4953 14.5454H7.75757V113.196H37.4953L89.0831 61.7377V81.6485L99.9438 92.5071V35.3619L32.9697 102.336H18.6182V25.406H32.9697L64.2589 56.8242L95.5471 25.406H109.899V102.336H95.5471L78.0926 84.8814L70.465 92.5081L91.0225 113.196H120.889V14.5454H91.0225Z",
    fill: "#F37328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5636 61.3498L49.6485 71.4347L57.406 63.8061L28.703 35.103V92.5091L39.5636 81.6485V61.3508",
    fill: "#F37328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomangM);
export default __webpack_public_path__ + "static/media/momang-m.756d4dd23a59ca938e86c96b0a4787dc.svg";
export { ForwardRef as ReactComponent };